export const ValidationType = {
    Email : "email",
    Password : "password",
    Name : "name"
  }
